import { render, staticRenderFns } from "./code_dialog.vue?vue&type=template&id=055c82dc&scoped=true&"
import script from "./code_dialog.vue?vue&type=script&lang=js&"
export * from "./code_dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055c82dc",
  null
  
)

export default component.exports